import Create from './create/CreateSftpConnection';
import Edit from './edit/EditSftpConnection';
import Individual from './individual/SftpConnection';

export default { Edit, Create, Individual };
